import { LayoutList, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import type { TimelineViewMode } from "@/features/timeline";

type TimelineViewToggleProps = {
  onChange: (value: TimelineViewMode) => void;
  value: TimelineViewMode;
};

export function TimelineViewToggle({ onChange, value }: TimelineViewToggleProps) {
  const { t } = useTranslation();

  return (
    <div className="inline-flex items-center gap-2 rounded-full border border-white/70 bg-white/75 p-1 shadow-vellum">
      <Button
        onClick={() => onChange("list")}
        size="sm"
        type="button"
        variant={value === "list" ? "default" : "ghost"}
      >
        <LayoutList className="h-4 w-4" />
        {t("timeline.viewToggle.list")}
      </Button>
      <Button
        onClick={() => onChange("graphical")}
        size="sm"
        type="button"
        variant={value === "graphical" ? "default" : "ghost"}
      >
        <Sparkles className="h-4 w-4" />
        {t("timeline.viewToggle.graphical")}
      </Button>
    </div>
  );
}
